import { Card, CardContent, Typography, Box } from "@mui/material";
import { Build } from "@mui/icons-material";
import { colors, alphaVar } from "../../../../../../../ui/colors";

export const TypeOfServiceCard = ({ service, onSelect, selected }) => {
  const isSelected = selected?.uid === service.uid;

  return (
    <Card
      onClick={() => onSelect?.(service)}
      sx={{
        backgroundColor: isSelected ? alphaVar(colors.orange[50], 0.7) : "var(--fx-surface-base, #FFFFFF)",
        borderRadius: 2,
        border: `2px solid ${isSelected ? colors.orange.base : alphaVar(colors.gray[100], 0.8)}`,
        boxShadow: isSelected ? `0 3px 8px ${alphaVar(colors.orange.base, 0.25)}` : "0 1px 2px rgba(0,0,0,0.05)",
        cursor: "pointer",
        transition: "all 0.2s ease",
        overflow: "hidden",
        "&:hover": {
          transform: "translateY(-1px)",
          boxShadow: `0 3px 6px ${alphaVar(colors.orange.base, 0.15)}`,
          borderColor: alphaVar(colors.orange.base, 0.3),
        },
        width: 200,
        height: 200,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        marginLeft: -6,

        p: 1.5,
      }}
    >
      <Box
        sx={{
          width: 26,
          height: 26,

          color: colors.orange.base,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "auto auto",

          flexShrink: 0,
        }}
      >
        {/* <Build sx={{ fontSize: 16 }} />*/}
        {/* Aqui voy a ponr el imageUrl del servivio*/}
        <Box component="img" src={service.imageUrl} sx={{ width: 120, height: 120, marginTop: 4 }} />
      </Box>

      <Typography
        variant="subtitle2"
        fontWeight={700}
        sx={{
          color: isSelected ? colors.orange[700] : colors.gray[500],
          fontSize: 13,
          lineHeight: 1.1,
          mb: 3,
          marginTop: 5,
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
      >
        {service.name}
      </Typography>

      <Typography
        variant="body2"
        sx={{
          marginTop: -2,
          color: colors.gray[300],
          fontSize: 11,
          lineHeight: 1.2,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
        }}
      >
        {service.description}
      </Typography>
    </Card>
  );
};
